export default __webpack_public_path__ + "static/media/cert-customer-hkgcsmeaa.bd9ac8c1.jpg";